import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  .menu {
    width: 100%;
    text-align: center;
    padding: 13px;

    font-weight: 500;
    font-size: 12px;
    line-height: 16px;

    transition: 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.orange.primary};
      color: ${({ theme }) => theme.colors.white};

      .submenu {
        display: block;
      }
    }

    div {
      font-size: 1.5rem;
    }

    p {
      margin-top: 8px;
    }

    .submenu {
      display: none;

      background: ${({ theme }) => theme.colors.gray[100]};

      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14),
        0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);

      position: absolute;
      left: 100%;
      top: 0;
      height: inherit;

      list-style: none;

      z-index: 1;
      padding: 8px 0;

      li a {
        font-weight: 500;
        font-size: 12px;

        display: flex;
        gap: 8px;
        align-items: center;

        color: ${({ theme }) => theme.colors.gray[600]};
        padding: 8px 12px;

        svg {
          color: ${({ theme }) => theme.colors.orange.primary};
        }

        &:hover {
          background-color: ${({ theme }) => theme.colors.orange.primary};
          color: ${({ theme }) => theme.colors.gray[100]};

          svg {
            color: ${({ theme }) => theme.colors.gray[100]};
          }
        }
      }
    }
  }

  .active {
    background-color: ${({ theme }) => theme.colors.orange.primary};
    color: ${({ theme }) => theme.colors.white};
  }
`;
